export enum StaticDotSize {
  SIZE_4 = 'SIZE_4',
  SIZE_6 = 'SIZE_6',
}

export enum StaticDotTheme {
  DARK = 'DARK',
  PURPLE = 'PURPLE',
  SUCCESS = 'SUCCESS',
}

export interface StaticDotProps {
  size: StaticDotSize;
  theme: StaticDotTheme;
  containerClassname?: string;
}
